import React from 'react';
import BlogManager from '../../components/admin/BlogManager';

const AdminBlogPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-cyan-50 p-6">
      <div className="max-w-7xl mx-auto">
        <BlogManager />
      </div>
    </div>
  );
};

export default AdminBlogPage;
